import NewSiteLayout from "./NewSiteLayout";
import NewSiteHomeContent from "@/components/new-site/home/NewSiteHomeContent";
import NewSiteAboutContent from "@/components/new-site/about/NewSiteAboutContent";
import NewSiteSolutionContent from "@/components/new-site/solution/NewSiteSolutionContent";
import NewSiteNewsContent from "@/components/new-site/news/NewSiteNewsContent";
import NewSiteNewsArticle from "@/components/new-site/news/NewSiteNewsArticle";
import NewSiteCaseStudiesContent from "@/components/new-site/case-studies/NewSiteCaseStudiesContent";
import NewSiteCaseStudyArticle from "@/components/new-site/case-studies/NewSiteCaseStudyArticle";
import NewSiteSectorsContent from "@/components/new-site/sectors/NewSiteSectorsContent";
import { NewSiteSeo, LAUNCH_PATHS as P, breadcrumb } from "@/components/new-site/seo";

export const NewSiteHome = () => (
  <NewSiteLayout>{(openContact) => (<>
    <NewSiteSeo
      path={P.home}
      title="Solar 4G Site Cameras for Remote Monitoring | Snapshot Live"
      description="Solar-powered 4G cameras that capture time-stamped images of remote sites. Lower cost, carbon and risk than video or site visits. Built to go where others can't."
    />
    <NewSiteHomeContent onContact={openContact} />
  </>)}</NewSiteLayout>
);

export const NewSiteAbout = () => (
  <NewSiteLayout>{(openContact) => (<>
    <NewSiteSeo
      path={P.about}
      title="About Snapshot Live | Image-Based Remote Site Monitoring"
      description="We provide image-based visual intelligence solutions that let organisations monitor blind spots remotely and gain real-time insights for proactive management."
      schema={[breadcrumb([["Home", P.home], ["About Us", P.about]])]}
    />
    <NewSiteAboutContent onContact={openContact} />
  </>)}</NewSiteLayout>
);

export const NewSiteSolution = () => (
  <NewSiteLayout>{(openContact) => (<>
    <NewSiteSeo
      path={P.solution}
      title="Solar Powered Camera & Monitoring Platform | Snapshot Live"
      description="Rugged solar-powered cameras with a secure cloud portal: scheduled and on-demand images, privacy blurring and AI alerts, with near zero maintenance."
      schema={[breadcrumb([["Home", P.home], ["Solution", P.solution]])]}
    />
    <NewSiteSolutionContent onContact={openContact} />
  </>)}</NewSiteLayout>
);

export const NewSiteNews = () => (
  <NewSiteLayout>{(openContact) => (<>
    <NewSiteSeo
      path={P.news}
      title="News | Snapshot Live"
      description="Technology rollouts, platform releases, partnerships and sector stories from Snapshot Live, helping UK infrastructure operators keep eyes in the field."
      schema={[breadcrumb([["Home", P.home], ["News", P.news]])]}
    />
    <NewSiteNewsContent onContact={openContact} />
  </>)}</NewSiteLayout>
);

export const NewSiteSectors = () => (
  <NewSiteLayout>{(openContact) => <NewSiteSectorsContent onContact={openContact} />}</NewSiteLayout>
);

export const NewSiteCaseStudies = () => (
  <NewSiteLayout>{(openContact) => (<>
    <NewSiteSeo
      path={P.caseStudies}
      title="Remote Camera Monitoring Case Studies | Snapshot Live"
      description="See how UK infrastructure, resilience, and construction teams use Snapshot Live to drive efficiency, mitigate hazards, and reduce carbon outputs."
      schema={[breadcrumb([["Home", P.home], ["Case Studies", P.caseStudies]])]}
    />
    <NewSiteCaseStudiesContent onContact={openContact} />
  </>)}</NewSiteLayout>
);

export const NewSiteCaseStudyPage = () => (
  <NewSiteLayout>{(openContact) => <NewSiteCaseStudyArticle onContact={openContact} />}</NewSiteLayout>
);

export const NewSiteNewsArticlePage = () => (
  <NewSiteLayout>{(openContact) => <NewSiteNewsArticle onContact={openContact} />}</NewSiteLayout>
);
